module.exports = __webpack_public_path__ + "img/74.877106d7.webp";